import { Tooltip } from '@user-interviews/ui-design-system';

import { registerComponent } from 'lib/react_on_rails';

registerComponent('Tooltip', Tooltip);

export default Tooltip;
